//manage edit billing fealds
document.addEventListener('DOMContentLoaded', function () {
   const currentUserRole = document.querySelector('input#billing_current_role');
   const userTypePrivato = document.querySelector('input#billing_user_role_customer');
   const userTypeAssociazione = document.querySelector('input#billing_user_role_associazione');
   const userTypeAzienda = document.querySelector('input#billing_user_role_azienda');
    const userTypeRadio = document.querySelectorAll('input[name="billing_user_role"]');
    const form = document.querySelector('form.perf-edit-myaccount');

    //billing fields
    const company = document.querySelector('input#billing_company');
    const piva = document.querySelector('input#billing_piva');
    const pec = document.querySelector('input#billing_elet');
    const cf = document.querySelector('input#billing_cf');
    addRequiredStars();


   if(form){
       switch (form.dataset.role) {
           case 'azienda':
               userTypeAzienda.checked = true
               userTypeRadio.forEach(el =>  el.disabled=true);
               break;
           case 'associazione':
               userTypeAssociazione.checked = true
               userTypeRadio.forEach(el =>  el.disabled=true);
               break;
           default:
               userTypePrivato.checked = true
               userTypeRadio.forEach(el =>  el.disabled=true);
               company.parentElement.parentElement.classList.add('d-none')
               piva.parentElement.parentElement.classList.add('d-none')
               pec.parentElement.parentElement.classList.add('d-none')
               cf.parentElement.parentElement.classList.add('d-none')
       }
   }

    function addRequiredStars(){
        let createRequiredStar = () => {
            let p = document.createElement('span');
            p.innerHTML = `<abbr class="required ps-2" title="obbligatorio">*</abbr>`;
            return p;
        }
        if(document.querySelector('p#billing_piva_field')){
            document.querySelector('p#billing_piva_field').firstElementChild.appendChild(createRequiredStar());
        }
        if(document.querySelector('p#billing_company_field')){
            document.querySelector('p#billing_company_field').firstElementChild.appendChild(createRequiredStar());
        }
        if(document.querySelector('p#billing_elet_field')){
            document.querySelector('p#billing_elet_field').firstElementChild.appendChild(createRequiredStar());
        }
        if(document.querySelector('p#billing_cf_field')){
            document.querySelector('p#billing_cf_field').firstElementChild.appendChild(createRequiredStar());
        }
    }

});